import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Form } from '@flux/flux-core';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({ providedIn: 'root' })
export class FormsService {
    constructor(private http: HttpClient, @Inject('env') private env) {}

    get(parentObject: string, action: string): Observable<Form> {
        return this.http.get<Form>(
            `${this.env.apiBaseUrl}services/fluxunicorn/api/forms/byObject/${parentObject}/byAction/${action}`
        );
    }

    getByFormKey(formKey: string): Observable<Form> {
        return this.http.get<Form>(`${this.env.apiBaseUrl}services/fluxunicorn/api/forms/byFormKey/${formKey}`);
    }
}
